import { createAction } from 'redux-actions';
import { actionKey } from './constants';
// for internal use - this has all duperbrowse-handled locations
export const duperbrowseHistoryChanged = createAction(`${actionKey}.HISTORY_CHANGED.DUPERBROWSE`, (location, action)=>({
        location,
        action
    }));
// for general use - this has all unhandled history updates
// (ie. anything not handled by duperbrowse)
export const historyChanged = createAction(`${actionKey}.HISTORY_CHANGED`, (location, action)=>({
        location,
        action
    }));

//# sourceMappingURL=actions.js.map